import script from "./DriverMobileApps.vue?vue&type=script&setup=true&lang=js"
export * from "./DriverMobileApps.vue?vue&type=script&setup=true&lang=js"

import "./DriverMobileApps.vue?vue&type=style&index=0&id=605ee914&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605ee914"]])

export default __exports__